const toggles = document.querySelectorAll('[data-load="search"]');
const searchOverlay = document.querySelector("[data-search-overlay]");
const searchOverlayBackground = document.querySelector("[data-search-overlay-background]");
const searchOverlayInput = document.querySelector("[data-search-overlay-input]");

toggles.forEach((toggle) => {
  toggle.addEventListener("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    const isActive = searchOverlay.classList.toggle("search-overlay--active");
    searchOverlayBackground.classList.toggle("search-overlay__background--active");
    if (isActive) {
      searchOverlayInput.focus();
      document.dispatchEvent(new Event("predictive-search:open"));
    } else {
      searchOverlayInput.blur();
    }
    document.documentElement.classList.toggle("lock");
  });
});
